import React, { useEffect, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import {
	Button,
	Image,
	InfiniteScroll,
	PullToRefresh,
	Toast,
} from "antd-mobile";
import FixedNavBar from "@/components/fixedNavBar";
import { AddCircleOutline } from "antd-mobile-icons";
import usePopup from "@/hooks/usePopup";
import Manage from "./comp/Manage";
import ManageRights from "./comp/ManageRights";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import API from "@/api";
import { showGlobalLoading } from "@/components/globalLoading";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";

const ManageMembers: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { userInfo } = useSelector((state: RootState) => state.auth);
	const userManage = useSelector(
		(state: RootState) => state.manageUser.userManage
	);
	const ManagePopup = usePopup();
	const RightsPopup = usePopup();
	const [agentRoleData, setAgentRoleData] = useState({});
	const [operateDelState, setOperateDelState] = useState(true);

	const [data, setData] = useState<any[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 40;
	const postUserAgentManagerListHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				// page: pageNum,
				// pageSize: pageSize,
			};
			const result: any = await API.members.postUserAgentManagerList(
				params
			);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---postUserAgentManagerList--:", error);
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postUserAgentManagerListHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postUserAgentManagerListHandle();
	};

	useEffect(() => {
		postUserAgentManagerListHandle();
	}, []);

	const userAgentInviteRoleHandle = async (params: Record<string, any>) => {
		const { showLoading, hideLoading } = showGlobalLoading();
		try {
			showLoading();
			const result: any = await API.members.postUserAgentInviteRole(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: params.agentRole
						? t("UpdateCompleted")
						: t("DeleteCompleted"),
					position: "top",
				});
				postUserAgentManagerListHandle();
			}
		} catch (error) {
			console.log("---postUserAgentInviteRole--:", error);
		} finally {
			hideLoading();
		}
	};

	const onSubmitHandle = (dataTights: string[]) => {
		if (isEmpty(userManage)) {
			return Toast.show({
				content: t("PSelectAddressMembers"),
				position: "top",
			});
		}
		const params: any = {
			id: userManage.uid,
		};
		let agentRole: any = {
			look: 1,
		};
		for (let index = 0; index < dataTights.length; index++) {
			const element = dataTights[index];
			if (!isEmpty(element)) {
				agentRole[element] = 1;
			}
		}
		params["agentRole"] = JSON.stringify(agentRole);
		userAgentInviteRoleHandle(params);
	};

	useEffect(() => {
		if (!isEmpty(userManage)) {
			RightsPopup.showPopup();
		}
	}, []);

	return (
		<div className="router-main">
			<FixedNavBar
				title={t("ManageMembers")}
				rightContent={[
					<div
						style={{ display: "flex", justifyContent: "flex-end" }}
						key={"manage"}
					>
						<Image
							onClick={() => setOperateDelState(false)}
							src={require("@/assets/images/icons/del.png")}
							width={24}
							height={24}
							key={"del"}
							style={{
								display: operateDelState ? "block" : "none",
							}}
						/>
						<Image
							onClick={() => setOperateDelState(true)}
							src={require("@/assets/images/icons/tick.png")}
							width={24}
							height={24}
							key={"tick"}
							style={{
								display: !operateDelState ? "block" : "none",
							}}
						/>
					</div>,
				]}
			/>
			<div className="router-view" style={{ paddingTop: pxToRem(15) }}>
				<PullToRefresh
					onRefresh={handleRefresh}
					canReleaseText={t("canReleaseText")}
					completeText={t("completeText")}
					pullingText={t("pullingText")}
					refreshingText={t("refreshingText")}
				>
					<div className={classes.alisonBox}>
						<Image
							src={require("@/assets/images/icons/Alison.png")}
							width={48}
							height={48}
						/>
						<p>{userInfo?.nickname}</p>
						<div className="operates">
							<Button
								size="small"
								style={{
									color: "#FFFFFF",
									"--text-color": "#FFFFFF",
									"--background-color": "#4C66C7",
									"--border-width": "0",
								}}
							>
								{t("Owner")}
							</Button>
						</div>
					</div>
					{data.map((item, index) => {
						return (
							<div className={classes.alisonBox} key={index}>
								<Image
									src={require("@/assets/images/icons/Alison.png")}
									width={48}
									height={48}
								/>
								<p>{item.nickname}</p>
								<div className="operates">
									{!operateDelState ? (
										<span
											onClick={() =>
												userAgentInviteRoleHandle({
													id: item.id,
													agentRole: null,
												})
											}
											className="del"
										>
											{t("Delete")}
										</span>
									) : (
										<Image
											onClick={() => {
												item.agentRole &&
													setAgentRoleData({
														id: item.id,
														data: JSON.parse(
															item.agentRole
														),
													});
												ManagePopup.showPopup();
											}}
											src={require("@/assets/images/icons/omit.png")}
											width={24}
											height={24}
										/>
									)}
								</div>
							</div>
						);
					})}
					<div
						onClick={() => {
							RightsPopup.showPopup();
						}}
						className={classes.addMembers}
					>
						<AddCircleOutline fontSize={34} color="#4C66C7" />
						<p>{t("AddMembers")}</p>
					</div>
					{data.length > 0 && (
						<InfiniteScroll
							loadMore={handleFetchMore}
							hasMore={hasMore}
						>
							<InfiniteScrollContent hasMore={hasMore} />
						</InfiniteScroll>
					)}
				</PullToRefresh>
			</div>

			<ManagePopup.PopupComp
				visible={ManagePopup.visiblePopup}
				onClose={ManagePopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ManagePopup.closePopup();
				}}
			>
				<Manage
					onVisiblePopup={ManagePopup.closePopup}
					agentRoleData={agentRoleData}
					onSubmit={userAgentInviteRoleHandle}
				/>
			</ManagePopup.PopupComp>

			<RightsPopup.PopupComp
				visible={RightsPopup.visiblePopup}
				onClose={RightsPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					RightsPopup.closePopup();
				}}
			>
				<ManageRights
					onVisiblePopup={RightsPopup.closePopup}
					onSubmit={onSubmitHandle}
				/>
			</RightsPopup.PopupComp>
		</div>
	);
};

export default ManageMembers;

const useStyles = createUseStyles({
	alisonBox: {
		display: "flex",
		alignItems: "center",
		height: pxToRem(72),
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		border: "1px solid #2F3A62",
		"& p": {
			flex: 1,
			overflow: "hidden",
			color: "#FFFFFF",
			fontSize: pxToRem(16),
			fontWeight: "500",
			paddingLeft: pxToRem(26),
		},
		"& .operates": {
			"& span.del": {
				color: "#FF6161",
				fontSize: pxToRem(16),
				fontWeight: "500",
			},
		},
	},
	addMembers: {
		display: "flex",
		alignItems: "center",
		height: pxToRem(72),
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		border: "1px solid #2F3A62",
		"& p": {
			flex: 1,
			overflow: "hidden",
			color: "#4C66C7",
			fontSize: pxToRem(16),
			fontWeight: "500",
			paddingLeft: pxToRem(26),
		},
	},
});
